import { Table } from '../../../../components/general/table';
import { FUNCTIONARIES_SWITCHBOARD_DETAIL } from '../../../../../routes/paths';
import { FunctionariesSwitchboardListProps } from './props';
import { useFunctionariesSwitchboardList } from './hook';

export const FunctionariesSwitchboardList = ({
    filters,
}: FunctionariesSwitchboardListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useFunctionariesSwitchboardList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(
                    `${FUNCTIONARIES_SWITCHBOARD_DETAIL}/${item.id}`,
                    '_blank'
                )
            }
        />
    );
};
